"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const images_1 = require("../../../assets/images");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const scale_1 = require("../../../utils/scale");
const IconComment_1 = __importDefault(require("../../../assets/icons/IconComment"));
const moment_1 = __importDefault(require("moment"));
const react_redux_1 = require("react-redux");
const slice_1 = require("../../../app-reduxs/articleLike/slice");
const IconLike_1 = __importDefault(require("../../../assets/icons/IconLike"));
const IconLiked_1 = __importDefault(require("../../../assets/icons/IconLiked"));
const IconThreeDoc_1 = __importDefault(require("../../../components/Icon/IconThreeDoc"));
const constants_1 = require("../../../constants");
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const Home_1 = __importDefault(require("../../../networking/apis/Home"));
const slice_2 = __importDefault(require("../../../app-reduxs/app/slice"));
const helpler_1 = require("../../../utils/helpler");
const tooltips_1 = require("../../../components/tooltips");
const CreateTimeView = ({ time }) => {
    const [visible, setVisible] = (0, react_1.useState)(false);
    return (react_1.default.createElement(react_native_1.View, { style: { zIndex: 1 } },
        react_1.default.createElement(CustomText_1.default, { style: {
                marginTop: (0, scale_1.scale)(12),
                fontSize: (0, scale_1.moderateScale)(12),
                lineHeight: (0, scale_1.moderateScale)(18),
                color: '#888888',
            }, onPress: () => {
                setVisible(!visible);
            } }, (0, moment_1.default)(time).format('YYYY/MM/DD')),
        visible && (react_1.default.createElement(CustomText_1.default, { style: styles.textTimeNow, weight: "300", numberOfLines: 1 }, (0, moment_1.default)(time).format('YYYY/MM/DD HH:mm')))));
};
const LikeButton = (props) => {
    const { liked, likes, data, myProfile } = props;
    const dispatch = (0, react_redux_1.useDispatch)();
    const articleLike = (0, react_redux_1.useSelector)((state) => state.articleLikeReducer);
    const [isLiked, setLiked] = (0, react_1.useState)(!!liked);
    const [numberLike, setNumberLike] = (0, react_1.useState)(likes);
    const refIsCallingApi = (0, react_1.useRef)(false);
    const isAnonymous = myProfile?.registration_status == 0;
    const refIsMounting = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        // CHECK COMPONENT RENDERED WILL BE UPDATE
        if (articleLike.article_id == data.article_id && refIsMounting.current) {
            setLiked(articleLike.isLike);
            setNumberLike(articleLike.isLike ? (numberLike + 1) : (numberLike - 1));
        }
        refIsMounting.current = true;
    }, [articleLike]);
    const callApiLikeArticles = async () => {
        if (isAnonymous) {
            return dispatch(slice_2.default.actions.showRequestLoginModal());
        }
        if (refIsCallingApi.current)
            return;
        refIsCallingApi.current = true;
        await Home_1.default.likeArticles(data?.article_id)
            .then((_res) => {
            // setLiked(true)
            // setNumberLike(numberLike + 1)
            dispatch((0, slice_1.addArticleToggleLikeAction)({ article_id: data.article_id, isLike: true }));
        })
            .catch((err) => {
            console.log(err);
        })
            .finally(() => {
            refIsCallingApi.current = false;
        });
    };
    const callApiUnLikeArticles = async () => {
        if (isAnonymous) {
            return dispatch(slice_2.default.actions.showRequestLoginModal());
        }
        if (refIsCallingApi.current)
            return;
        refIsCallingApi.current = true;
        await Home_1.default.unLikeArticles(data?.article_id)
            .then((_res) => {
            // setLiked(false)
            // setNumberLike(numberLike - 1)
            dispatch((0, slice_1.addArticleToggleLikeAction)({ article_id: data.article_id, isLike: false }));
        })
            .catch((err) => {
            console.log(err);
        })
            .finally(() => {
            refIsCallingApi.current = false;
        });
    };
    return (react_1.default.createElement(react_native_1.TouchableOpacity, { style: { flexDirection: 'row', alignItems: 'center', marginLeft: (0, scale_1.scale)(24) }, onPress: () => {
            if (isLiked) {
                callApiUnLikeArticles();
            }
            else {
                callApiLikeArticles();
            }
        } },
        !isLiked ? react_1.default.createElement(IconLike_1.default, { color: '#545454' }) : react_1.default.createElement(IconLiked_1.default, null),
        react_1.default.createElement(CustomText_1.default, { style: {
                fontSize: (0, scale_1.moderateScale)(12),
                fontWeight: '300',
                lineHeight: (0, scale_1.moderateScale)(18),
                color: isLiked ? '#44A06B' : '#545454',
                marginLeft: (0, scale_1.scale)(8),
                marginRight: (0, scale_1.scale)(24),
            } }, numberLike)));
};
const ItemArticles = (props) => {
    const { data, typeHashTag = true, typeScreen = 0, showCreatedAt = false, displayTweet, displayBlock = false, } = props;
    const dispatch = (0, react_redux_1.useDispatch)();
    const myProfile = (0, react_redux_1.useSelector)((state) => state.loginReducer.dataProfile);
    const isAnonymous = myProfile?.registration_status == 0;
    const navigateToUserProfile = () => {
        (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
            screen: Routes_1.default.USER_PROFILE,
            params: {
                userHandle: data.user_handle,
            },
        });
    };
    return (react_1.default.createElement(react_native_1.View, { style: {
            paddingVertical: (0, scale_1.scale)(12),
            width: (0, scale_1.scale)(343),
            paddingTop: (0, scale_1.scale)(12),
            marginRight: (0, scale_1.scale)(10),
        } },
        react_1.default.createElement(react_native_1.Pressable, { onPress: () => (0, rootNavigation_1.push)(Routes_1.default.DETAIL_STORY, { id: data.article_id }) },
            react_1.default.createElement(react_native_1.Image, { source: data?.article_thumbnail_url
                    ? { uri: data?.article_thumbnail_url }
                    : images_1.images.NoImages, style: {
                    height: (0, scale_1.scale)(192),
                    width: (0, scale_1.scale)(343),
                    borderRadius: (0, scale_1.scale)(8),
                }, resizeMode: "cover" }),
            react_1.default.createElement(react_native_1.View, { style: { width: (0, scale_1.scale)(343) } },
                react_1.default.createElement(react_native_1.View, { style: {
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: (0, scale_1.scale)(16),
                    } },
                    react_1.default.createElement(CustomText_1.default, { numberOfLines: 1, style: {
                            fontSize: (0, scale_1.moderateScale)(14),
                            lineHeight: (0, scale_1.moderateScale)(21),
                            fontWeight: '300',
                            maxWidth: (0, scale_1.scale)(300),
                            color: '#292A33',
                        } }, data?.title),
                    react_1.default.createElement(react_native_1.TouchableOpacity, null,
                        react_1.default.createElement(IconThreeDoc_1.default, { data: data, uri: `${window.location.origin}/article/detail-story/${data?.article_id}`, displayTweet: () => {
                            }, displayBlock: displayBlock }))),
                react_1.default.createElement(react_native_1.View, null,
                    !!data?.hash_tags?.length && (react_1.default.createElement(react_native_1.View, { style: {
                            marginTop: (0, scale_1.scale)(4),
                            width: '100%',
                            flexDirection: 'row',
                            flexWrap: 'wrap',
                            gap: (0, scale_1.scale)(4),
                        } }, data?.hash_tags?.map((item, index) => {
                        return (react_1.default.createElement(CustomText_1.default, { key: index, style: {
                                fontSize: (0, scale_1.moderateScale)(12),
                                lineHeight: (0, scale_1.moderateScale)(18),
                                color: '#007AFF',
                            }, onPress: () => {
                                (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                                    screen: Routes_1.default.HASHTAG_DETAIL,
                                    params: {
                                        typeScreen: 0,
                                        hashtag: item?.name,
                                        typeHashTag: typeHashTag ? 1 : 2,
                                    },
                                });
                            } }, `#${item?.name}`));
                    }))),
                    react_1.default.createElement(react_native_1.View, { style: {
                            flexDirection: 'row',
                            width: (0, scale_1.scale)(343),
                            marginTop: (0, scale_1.scale)(12),
                        } },
                        react_1.default.createElement(react_native_1.View, { style: { width: (0, scale_1.scale)(52) } },
                            react_1.default.createElement(react_native_1.Pressable, { onPress: navigateToUserProfile },
                                react_1.default.createElement(react_native_1.Image, { source: data?.user_thumbnail_url
                                        ? { uri: data?.user_thumbnail_url }
                                        : images_1.images.AvatarDefaul, style: {
                                        height: (0, scale_1.scale)(42),
                                        width: (0, scale_1.scale)(42),
                                        borderRadius: 999,
                                    } }))),
                        react_1.default.createElement(react_native_1.View, { style: { width: (0, scale_1.scale)(290) } },
                            react_1.default.createElement(react_native_1.View, { style: {
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                } },
                                react_1.default.createElement(react_native_1.View, null,
                                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row' } },
                                        react_1.default.createElement(CustomText_1.default, { weight: "300", numberOfLines: 1, style: {
                                                fontSize: (0, scale_1.moderateScale)(14),
                                                lineHeight: (0, scale_1.moderateScale)(21),
                                                maxWidth: (0, scale_1.scale)(200),
                                                color: '#292A33',
                                            }, onPress: navigateToUserProfile }, data?.nickname ||
                                            data?.user_nickname ||
                                            constants_1.DEFAULT_NAME)),
                                    react_1.default.createElement(react_native_1.View, { style: {
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        } },
                                        react_1.default.createElement(CustomText_1.default, { style: {
                                                maxWidth: (0, scale_1.scale)(240),
                                                fontSize: (0, scale_1.moderateScale)(10),
                                                lineHeight: (0, scale_1.moderateScale)(15),
                                                marginTop: (0, scale_1.scale)(5),
                                                color: '#888888',
                                            } },
                                            "@",
                                            data?.user_handle)))))),
                    react_1.default.createElement(react_native_1.View, { style: { marginTop: (0, scale_1.scale)(12) } },
                        react_1.default.createElement(tooltips_1.DateTimeTooltip, { title: (0, moment_1.default)(data.createdAt || data.posting_datetime).format('YYYY/MM/DD HH:mm') }, `${(0, helpler_1.stringToDateFormat)(data.createdAt || data.posting_datetime)} `)),
                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row', marginTop: (0, scale_1.scale)(12) } },
                        react_1.default.createElement(react_native_1.TouchableOpacity, { style: { flexDirection: 'row', alignItems: 'center' }, onPress: () => {
                                if (isAnonymous) {
                                    return dispatch(slice_2.default.actions.showRequestLoginModal());
                                }
                                (0, rootNavigation_1.navigate)(Routes_1.default.REP_COMMENT_ARTICLE, {
                                    article: data?.article_id,
                                    type: 'POST',
                                });
                            } },
                            react_1.default.createElement(IconComment_1.default, { color: '#545454' }),
                            react_1.default.createElement(CustomText_1.default, { style: {
                                    fontSize: (0, scale_1.moderateScale)(12),
                                    fontWeight: '300',
                                    lineHeight: (0, scale_1.moderateScale)(18),
                                    color: '#545454',
                                    marginLeft: (0, scale_1.scale)(8),
                                } }, data?.comments || 0)),
                        react_1.default.createElement(LikeButton, { liked: data.is_liked, likes: data.likes, data: data, myProfile: myProfile })))))));
};
const styles = react_native_1.StyleSheet.create({
    textTime: {
        fontSize: (0, scale_1.moderateScale)(10),
        lineHeight: (0, scale_1.moderateScale)(17),
        color: '#888888',
        // marginLeft: scale(12),
    },
    textTimeNow: {
        fontSize: (0, scale_1.moderateScale)(9),
        lineHeight: (0, scale_1.moderateScale)(14),
        color: '#FEFEFE',
        backgroundColor: 'black',
        paddingHorizontal: (0, scale_1.scale)(2),
        top: (0, scale_1.scale)(30),
        position: 'absolute',
        minWidth: (0, scale_1.scale)(90),
        left: (0, scale_1.scale)(-10),
        textAlign: 'center',
    },
});
exports.default = ItemArticles;
